import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProjectsPage from "./pages/ProjectsPage";
import ArchivedProjectsPage from "./pages/ArchivedProjectsPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import InventoryPage from "./pages/InventoryPage";
import CalendarPage from "./pages/CalendarPage";
import UsersPage from "./pages/UsersPage";
import TimeClockPage from "./pages/TimeClockPage";
import DeliveriesPage from "./pages/DeliveriesPage";
import VendorsPage from "./pages/VendorsPage";
import PurchaseOrdersPage from "./pages/PurchaseOrdersPage";
import SalesPage from "./pages/SalesPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import PendingApprovalsPage from "./pages/PendingApprovalsPage";
import OffSiteDeliveriesPage from "./pages/OffSiteDeliveriesPage";
import InstallPrompt from "./components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetailsPage />} />
            <Route path="/deliveries" element={<DeliveriesPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/archived" element={<ArchivedProjectsPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/off-site-deliveries" element={<OffSiteDeliveriesPage />} />
            <Route path="/vendors" element={<VendorsPage />} />
            <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
            <Route path="/sales" element={<SalesPage />} />
            <Route path="/sales/clients/:id" element={<ClientDetailPage />} />
            <Route path="/pending-approvals" element={<PendingApprovalsPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/time" element={<TimeClockPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <InstallPrompt />
    </AuthProvider>
  );
}

export default App;
